import { atom } from 'recoil'
import { User } from './types'
import { localStorageEffect } from 'utils/store/localstorage.effect'

// TODO: Move to auth service.

export const currentUserState = atom<User>({
  key: 'CurrentUserState',
  default: { id: '', name: '' },
  effects: [localStorageEffect('user')],
})
